import { PostType, EnquiryConfig, initEnquiryForm } from "./enquiry-form";

declare const jQuery: any;
const $ = jQuery;

const ajaxCall: Function = window["iw"].utils.ajaxCall;

interface UpdateResult {
    ok: boolean;
    nextOffset: number; // -1 if no next offset
    totalItems: number;
    itemsHtml: number; // to be added to items container, not replace it
}

interface UpdateConfig {
    s: string;
    offset: number;
}

export function initSearchPage(): void {
    if (!$(document.body).hasClass("search")) {
        return;
    }

    const $itemsWrap = $(".hs-search-results [data-items]").first();
    if ($itemsWrap.length === 0) {
        console.error(`Failed to find [data-items]`);
        return;
    }

    const $enquiryPopup = $(`[data-popup="enquiry"]`);
    if ($enquiryPopup.length === 0) {
        console.error(`No enquiry popup found on search page`);
    }

    initPostCardEnquireButtons($itemsWrap.add(`.hs-search-result-hi-priority`), $enquiryPopup);
    initSearchPageLoadMore($itemsWrap, $enquiryPopup);
    preventEmptySearchSubmit();
}

export function preventEmptySearchSubmit(): void {
    const $wrap = $(`.hs-search-page-input`);
    if ($wrap.length === 0) {
        return;
    }
    const $form = $wrap.find("form");
    const $input = $form.find("[data-suggest-input]");
    if ($input.length === 0) {
        return;
    }
    $form.on("submit", function (event) {
        if (!$.trim($input.val() || "")) {
            event.preventDefault();
            return false;
        }
    });
}

export function initSearchPageLoadMore($itemsWrap, $enquiryPopup): void {
    const $btn = $("[data-search-load-more]");
    if ($btn.length === 0) {
        return;
    }
    
    let offset: number = parseInt($btn.attr("data-initial-length"), 10);
    if (!offset) {
        console.error(`Got unexpected offset:`, offset);
        return;
    }
    const s: string = $.trim($btn.attr("data-search-load-more") || "");
    if (!s) {
        console.error(`No s`);
        return;
    }
    const $btnWrap = $btn.closest(".load-more-wrap");
    
    let busy = false;
    
    // Updates the post item cards with fresh server data
    // Returns success bool
    const updateResults = async (updateConfig: UpdateConfig): Promise<boolean> => {
        if (busy) {
            return;
        }
        busy = true;
        $itemsWrap.addClass("busy");
        $btn.attr("disabled", "disabled").addClass("busy-button");
        let result: UpdateResult;
        try
        {
            result = await ajaxCall("hs_fetch_search_page_results", updateConfig);
            if (!result || !result.ok)
            {
                console.error(`Fetch error result:`, result);
                throw new Error(`No result/result.ok in fetch result obj`);
            }
            if (result.nextOffset < 0)
            {
                $btnWrap.remove();
            }
            else
            {
                offset = result.nextOffset;
            }
        }
        catch (error)
        {
            console.error("Fetch on search page failed", error);
            return false;
        }
        finally
        {
            $itemsWrap.removeClass("busy");
            $btn.removeAttr("disabled").removeClass("busy-button");
            busy = false;
        }
        $itemsWrap.append(result.itemsHtml);
        initPostCardEnquireButtons($itemsWrap, $enquiryPopup);
        return true;
    };
    $btn.on("click", function (event) {
        updateResults({ offset, s });
    });
}

function initPostCardEnquireButtons($itemsWrap, $enquiryPopup): void {
    $itemsWrap.find(`[data-post-id]`).each(function (): void {
        const $wrap = $(this);
        const postId: number = parseInt($wrap.attr("data-post-id"), 10);
        if (!postId) {
            console.error(`data-post-id missing on post card`, this);
            return;
        }
        const $enquiryBtn = $wrap.find(`.enquiry-button`);
        if ($enquiryBtn.length === 0) {
            return;
        }
        if ($enquiryPopup.length === 0) {
            console.error(`No enquiry popup found for post item enquiry buttons`);
            return;
        }
        const postTitle: string = $wrap.attr("data-post-title");
        if (!postTitle) {
            console.error(`No postTitle for post ${postId}`);
            return;
        }
        const postType: PostType = $wrap.attr("data-post-type") as PostType;
        if (!postType) {
            console.error(`No postType for post ${postId}`);
            return;
        }
        const defaultEnquiryText: string = `Enquiry about ${postTitle}: `;
        const config: EnquiryConfig = { postId, postType };
        $enquiryBtn.off("click").on("click", function (event): false {
            event.preventDefault();
            event.stopPropagation();
            setupEnquiryPopupSubmit($enquiryPopup, config, defaultEnquiryText);
            $enquiryPopup.trigger("open");
            return false;
        });
    });
}

function setupEnquiryPopupSubmit($enquiryPopup, config: EnquiryConfig, defaultEnquiryText: string): void {
    const $formWrap = $enquiryPopup.find(`.hs-enquiry-form`);
    $formWrap.off("success complete error submit").on("success", (event) => {
        $enquiryPopup.removeClass("busy");
        const timer = setTimeout(() => {
            $enquiryPopup.trigger("close");
        }, 5000);
        $enquiryPopup.one("close", () => {
            clearTimeout(timer);
        });
    }).on("complete", (event) => {
        $enquiryPopup.removeClass("busy");
    }).on("error", (event) => {
        $enquiryPopup.removeClass("busy").addClass("error");
    }).on("submit", (event) => {
        $enquiryPopup.addClass("busy");
    });
    initEnquiryForm($formWrap, config, defaultEnquiryText);
}
